import { create } from 'apisauce'
import authStorage from './storage'
import { notifyNotAuthorizedResponse } from './authSessionEvents'

/** Cron / reminder worker API (separate from main app and admin realtime hosts). */
const base_url = 'https://sparkle-timein-backend-fgg5.onrender.com/api'  //import.meta.env.VITE_API_URL_CRON

const apiClient = create({
  baseURL: base_url,
  timeout: 30000,
})

apiClient.addAsyncRequestTransform(async (request) => {
  const authToken = await authStorage.getToken()
  if (!authToken) return
  request.headers['Authorization'] = `Bearer ${authToken}`
})

apiClient.addResponseTransform((response) => {
  notifyNotAuthorizedResponse(response)
})

export default apiClient
